<template>
    <button v-on:click="showEntryForm()" v-if="$store.getters.userProfile && isOnline" class="w3-button w3-border w3-border-green w3-green w3-hover-white" style="width:100px;">Nevezek</button>        
</template>

<script>
export default {
    name: 'Entry',
    props: ['route'],
    methods:{
        showEntryForm(){
            if (this.$store.getters.userProfile) {
                var check=this.$checkUserData(this.$store.getters.userProfile,this.route.price)
                if (check==0) {
                   this.$router.push({name:'entryform', params: { route:this.route } });   
                } else {
                    if (check==1)
                        this.$dialog.alert(this.$setDialogMsg('w3-yellow',"Figyelmeztetés!","Nevezés előtt meg kell adni a számlázási és postázási adatokat!<br>Az adatok megadása után kattints újra a NEVEZÉS gombra.")).then(r=>{
                            this.$router.push('/userdata');
                        });                    
                    if (check==2)
                        this.$dialog.alert(this.$setDialogMsg('w3-yellow',"Figyelmeztetés!","Nevezés előtt meg kell adni a személyes adatokat (Publikus név, Neme, Születési év)!<br>Az adatok megadása után kattints újra a NEVEZÉS gombra.")).then(r=>{
                            this.$router.push('/userdata');
                    });                    
                }
            } else {
                this.$dialog.alert(this.$setDialogMsg('w3-yellow',"Figyelmeztetés!","A nevezéshez be kell jelentkezni!")).then(r=>{
                });
            }
        },
    },
    created:function(){
    }
}
</script>
